'use client'

import Container from '@/components/structure/Container'
import Title from '@/components/content/common/Title'
import Marquee from '@/components/ui/Marquee'
import Spliner from '@/lib/spline'

import type { App } from '@/payload-types'
import AppIcon from '@/components/content/app/AppIcon'

type HomeAppsProps = {
  apps: Pick<App, 'id' | 'slug' | 'icon' | 'glyph' | 'brandBackgroundColor' | 'name'>[]
}

export default function HomeApps({ apps }: HomeAppsProps) {
  return (
    <div className="flex flex-col overflow-hidden">
      <Container reduced={true} className="relative z-20">
        <Title
          icon={
            <Spliner
              scene="/splines/logo-primary.splinecode"
              fallback="/splines/logo-primary-fallback.png"
              loadStrategy="after-interaction-idle"
              showFallbackOnDesktop
            />
          }
          title="Smarter choices are <span>efficient.</span> Your next tool is waiting."
          paragraphs={[
            'Find your next tool. Stack smarter.',
            `Start exploring software that's actually worth your time.`,
          ]}
          buttons={[
            { label: 'Explore app reviews', link: '/apps' },
            { label: 'Subscribe to updates', link: '/subscribe' },
          ]}
          type="primary"
        />
      </Container>

      <div className="relative left-1/2 z-10 flex w-[150%] -translate-x-1/2 translate-y-5 rotate-[-16deg] skew-x-[16deg] flex-col gap-3 pb-32 md:w-[125%]">
        <Marquee>
          <div className="flex items-center gap-5 pb-2 pl-5">
            {apps.slice(0, 15).map((app) => (
              <AppIcon
                key={app.id}
                icon={app.icon}
                glyph={app.glyph}
                name={app.name}
                slug={app.slug}
                background={app.brandBackgroundColor}
                size={96}
                className="shadow-md"
              />
            ))}
          </div>
        </Marquee>
        <Marquee>
          <div className="flex items-center gap-5 pb-2 pl-5">
            {apps.slice(15, 30).map((app) => (
              <AppIcon
                key={app.id}
                icon={app.icon}
                glyph={app.glyph}
                name={app.name}
                slug={app.slug}
                background={app.brandBackgroundColor}
                size={96}
                className="shadow-md"
              />
            ))}
          </div>
        </Marquee>
      </div>
    </div>
  )
}
